import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// New marketing site (implemented from the "Tarana Website.html" design)
import { SiteLayout } from './site/SiteLayout';
import { Home } from './site/pages/Home';
import { ForArtists } from './site/pages/ForArtists';
import { ForOrganizations } from './site/pages/ForOrganizations';
import { ForListeners } from './site/pages/ForListeners';
import { Pricing } from './site/pages/Pricing';
import { About } from './site/pages/About';
import { Terms } from './site/pages/Terms';
import { PrivacyPolicy } from './site/pages/PrivacyPolicy';
import { ContentPolicy } from './site/pages/ContentPolicy';
import { CommunityGuidelines } from './site/pages/CommunityGuidelines';
import { Download as DownloadApp } from './site/pages/Download';

// Legacy pages (kept reachable for reference / unported flows)
import { DownloadRedirect } from './webcomponents/DownloadRedirect';

import './App.css';

function App() {
  useEffect(() => {
    const shell = document.getElementById('static-shell');
    if (shell) shell.style.display = 'none';
  }, []);

  return (
    <Router>
      <Routes>
        {/* Tarana redesign */}
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/for-artists" element={<ForArtists />} />
          <Route path="/for-organizations" element={<ForOrganizations />} />
          <Route path="/for-listeners" element={<ForListeners />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/about" element={<About />} />
          <Route path="/terms-of-use" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/content-policy" element={<ContentPolicy />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/download" element={<DownloadApp />} />
        </Route>

        {/* Redirects for old paths */}
        <Route path="/about-us" element={<Navigate to="/about" replace />} />
        <Route path="/privacy-policies" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/content-policies" element={<Navigate to="/content-policy" replace />} />

        {/* Legacy pages not yet redesigned */}
        <Route path="/redirect" element={<DownloadRedirect />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
 
